import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ChipView from './chipView';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './banner';
import Guest from './guest';
import Foot from './foot';
import Trivia from './trivia';
import VideoMask from './videoMask';

const Layout = ({ content }) => {
    const [maskVisible, setMaskVisible] = useState(false);
    const [currentVideo, setCurrentVideo] = useState({});
    const {
        guestNameList,
        bannerPreview,
        guestTrivia1,
        guestTrivia2,
        guestTrivia3,
        guestTrivia4,
        guestTrivia5,
        guestTrivia6,
        guestTrivia7,
        guestTrivia8,
        guestTrivia9,
        guestTrivia10,
        guestTrivia11,
        guestTrivia12,
        brandInfo,
        previouseview,
        qrcodeList,
        guestVideoList1,
        guestVideoList2,
        guestVideoList3,
        guestVideoList4,
        guestVideoList5,
        guestVideoList6,
        guestVideoList7,
        guestVideoList8,
        guestVideoList9,
        guestVideoList10,
        guestVideoList11,
        guestVideoList12,
    } = content;

    const guestData = [
        guestVideoList1,
        guestVideoList2,
        guestVideoList3,
        guestVideoList4,
        guestVideoList5,
        guestVideoList6,
        guestVideoList7,
        guestVideoList8,
        guestVideoList9,
        guestVideoList10,
        guestVideoList11,
        guestVideoList12,
    ];
    const triviaData = [guestTrivia1, guestTrivia2, guestTrivia3, guestTrivia4, guestTrivia5, guestTrivia6, guestTrivia7, guestTrivia8, guestTrivia9, guestTrivia10, guestTrivia11, guestTrivia12];
    const footData = {
        brandInfo,
        previouseview,
        qrcodeList,
    };
    const [navIndex, setNavIndex] = useState(() => {
        let hasActive = false;
        let indexNum = 0;

        guestNameList.forEach((item, index) => {
            if (item.isActive && !hasActive) {
                hasActive = true;
                indexNum = index;
            }
        });

        return indexNum;
    });

    return (
        <div className={styles.layout}>
            <Banner content={bannerPreview} onChangeMaskVisible={setMaskVisible} onChangeCurrentVideo={setCurrentVideo} />
            <Guest content={guestData} guestNameList={guestNameList} navIndex={navIndex} setNavIndex={setNavIndex} onChangeMaskVisible={setMaskVisible} onChangeCurrentVideo={setCurrentVideo} />
            <Trivia content={triviaData} guestNameList={guestNameList} navIndex={navIndex} setNavIndex={setNavIndex} />
            <Foot content={footData} />
            <VideoMask visible={maskVisible} onChangeVisible={setMaskVisible} videoInfo={currentVideo} />
            <ChipView />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
